{
  "name": "MCA",
  "version": "1.19.0",
  "scripts": {
    "ng": "ng",
    "start:mca": "ng serve --project=mca-app --configuration=development",
    "start:mcl": "ng serve --project=mcl-app --configuration=development --port 4200",
    "start:pwd-auth": "ng serve --project=pwd-auth-app --configuration=development",
    "start:dochub": "ng serve --project=document-hub-app --configuration=development",
    "build:mca": "ng build --project=mca-app --configuration=production --localize",
    "build:mcl": "ng build --project=mcl-app --configuration=production --localize",
    "build:pwd-auth": "ng build --project=pwd-auth-app --configuration=production",
    "build:dochub": "ng build --project=document-hub-app --configuration=production --localize",
    "staging:mca": "ng build --project=mca-app --configuration=staging --localize",
    "staging:mcl": "ng build --project=mcl-app --configuration=staging --localize",
    "build-release-candidate:mca": "npm run prettier-check && npm run lint && npm run test && npm run e2e-docker && npm run build:mca",
    "build-release-candidate:mcl": "npm run prettier-check && npm run lint && npm run test && npm run e2e-docker && npm run build:mcl",
    "build-release-candidate:dochub": "npm run prettier-check && npm run lint && npm run test && npm run e2e-docker && npm run build:dochub",
    "watch": "ng build --watch --configuration=development",
    "lint": "ng lint",
    "test": "jest --clearCache && jest --config jest-angular-config.js --runInBand",
    "test:clearCache": "jest --config jest-angular-config.js --clearCache",
    "e2e": "jest --clearCache && jest --config jest-puppeteer-e2e-ui-config.js --runInBand",
    "e2e-docker": "npm run docker-build && npm run e2e-docker-fast",
    "e2e-docker-fast": "npm run docker-up && npm run e2e & npm run docker-down",
    "prettier-check": "prettier --check .",
    "prettier-write": "prettier --write . --list-different",
    "docker-build": "docker-compose -f docker-compose.staging.yml build",
    "docker-up": "docker-compose -f docker-compose.staging.yml up -d",
    "docker-down": "docker-compose -f docker-compose.staging.yml down",
    "i18n:extract:mca": "ng extract-i18n --project=mca-app --output-path projects/mca-app/src/locale",
    "i18n:extract:mcl": "ng extract-i18n --project=mcl-app --output-path projects/mcl-app/src/locale",
    "i18n:extract:dochub": "ng extract-i18n --project=document-hub-app --output-path projects/document-hub-app/src/locale",
    "jenkins-build:mca": "npm run build:mca",
    "jenkins-build:mcl": "npm run build:mcl",
    "jenkins-build:dochub": "npm run build:dochub",
    "jenkins-install": "npm install --registry=https://registry.npmjs.org/ --include=optional --legacy-peer-deps",
    "jenkins-upload-source-files": "node node_modules/@meddev/fe-shared/bin/utils/upload-source-maps.js",
    "prepare": "husky install || true"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/localize": "^21.2.18",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/pwa": "^21.2.19",
    "@angular/router": "^21.2.18",
    "@angular/service-worker": "^21.2.18",
    "@bugsnag/angular-performance": "^3.0.0",
    "@bugsnag/browser-performance": "^3.0.0",
    "@bugsnag/core": "^8.6.0",
    "@bugsnag/js": "^8.6.0",
    "@bugsnag/plugin-angular": "^8.6.0",
    "@elastic/apm-rum-angular": "^3.0.7",
    "@iplab/ngx-file-upload": "^21.0.0",
    "@meddev/fe-shared": "4.0.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.8.2",
    "@ngxs/logger-plugin": "^21.0.0",
    "@ngxs/router-plugin": "^21.0.0",
    "@ngxs/storage-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "@popperjs/core": "^2.11.8",
    "@stripe/stripe-js": "^8.0.0",
    "agora-rtc-sdk-ng": "^4.22.0",
    "bootstrap": "^5.3.8",
    "class-transformer": "^0.5.1",
    "dayjs": "^1.11.13",
    "file-saver": "^2.0.5",
    "i18n-iso-countries": "^7.14.0",
    "jwt-decode": "^4.0.0",
    "line-awesome": "^1.3.0",
    "lodash": "4.17.21",
    "mime": "^4.1.0",
    "ng-recaptcha-2": "^21.0.1",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-cookie-service": "^21.3.1",
    "ngx-matomo-client": "^9.1.0",
    "ngx-stripe": "^21.8.0",
    "pdfjs-dist": "^5.7.284",
    "rxjs": "^7.8.1",
    "sweetalert2": "11.23.0",
    "tslib": "^2.8.1",
    "uuid": "^11.0.3",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@babel/core": "^7.24.4",
    "@babel/preset-env": "^7.24.4",
    "@babel/preset-typescript": "^7.24.1",
    "@eslint/js": "^9.39.5",
    "@meddev/eslint-config-angular": "^3.0.0",
    "@meddev/prettier-config": "^2.0.0",
    "@meddev/staged-config": "^1.0.2",
    "@ngneat/spectator": "^21.0.1",
    "@ngxs/devtools-plugin": "^21.0.0",
    "@types/expect-puppeteer": "^5.0.6",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "^30.0.0",
    "@types/jest-environment-puppeteer": "^5.0.6",
    "@types/lodash": "^4.17.0",
    "@types/node": "^24.5.0",
    "@types/puppeteer": "^5.4.7",
    "@typescript-eslint/eslint-plugin": "^8.44.0",
    "@typescript-eslint/parser": "^8.44.0",
    "angular-in-memory-web-api": "0.21.0",
    "autoprefixer": "^10.4.19",
    "babel-jest": "30.4.1",
    "eslint": "9.39.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-formatter-checkstyle": "^9.0.1",
    "eslint-import-resolver-typescript": "^3.6.1",
    "eslint-plugin-boundaries": "^4.2.2",
    "eslint-plugin-prettier": "5.5.4",
    "husky": "^9.0.11",
    "jest": "30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "^16.2.0",
    "jest-puppeteer": "^10.0.1",
    "lint-staged": "^16.2.6",
    "ng-packagr": "^21.2.5",
    "postcss": "^8.4.21",
    "prettier": "^3.9.5",
    "prettier-eslint": "^16.3.0",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "prettier-plugin-organize-imports": "^4.3.0",
    "puppeteer": "^22.6.5",
    "ts-jest": "^29.4.11",
    "typescript": "5.9.3"
  },
  "optionalDependencies": {
    "@nx/nx-linux-x64-musl": "18.3.2",
    "@nx/nx-win32-x64-msvc": "18.3.2"
  }
}
